/**
 * 平滑滚动
 * @param {Element} el 滚动容器元素
 * @param {Number} position
 * @returns
 */
export const smoothScroll = (el, position, vertical = true) => {
  return new Promise(resolve => {
    // 使用requestAnimationFrame，如果没有则使用setTimeOut
    if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function (callback) {
        return setTimeout(callback, 20);
      };
    }

    let scrollTopDistance;
    // 获取当前元素滚动的距离
    if (vertical) {
      scrollTopDistance = el.scrollTop;
    } else {
      scrollTopDistance = el.scrollLeft;
    }

    function startScroll() {
      // 如果你要滚到顶部，那么position传过来的就是0，下面这个distance肯定就是负值。
      let distance = position - scrollTopDistance;

      if (vertical) {
        if (position > el.scrollHeight - el.offsetHeight) {
          distance = el.scrollHeight - el.offsetHeight - el.scrollTop;
        }
      } else {
        if (position > el.scrollWidth - el.offsetWidth) {
          distance = el.scrollWidth - el.offsetWidth - el.scrollLeft;
        }
      }

      // 每次滚动的距离要不一样，制造一个缓冲效果
      scrollTopDistance = scrollTopDistance + distance / 4;
      // 判断条件
      if (Math.abs(distance) < 1) {
        if (vertical) {
          el.scrollTop = position;
        } else {
          el.scrollLeft = position;
        }
        resolve();
      } else {
        if (vertical) {
          el.scrollTop = scrollTopDistance;
        } else {
          el.scrollLeft = scrollTopDistance;
        }

        requestAnimationFrame(startScroll);
      }
    }

    startScroll();
  });
};
